import { mapping } from 'ui/themes/mapping';

export const DEFAULT_APP_SETTINGS = {
  mapping,
  theme: 'light',
};
